'use client';

import RichText from '@/components/ui/RichText/RichText';
import { SubmitComplaintPageData } from '@/features/submitComplaint/data/types';

type ComplaintsInformationSectionProps = {
  data: SubmitComplaintPageData;
};

export default function ComplaintsInformation({
  data,
}: ComplaintsInformationSectionProps) {
  return (
    <section className="content-wrapper">
      <RichText styles={data.intro.styles}>{data.intro.content}</RichText>
      <hr className="mx-auto my-9 max-w-4xl border-gray-200" />
      <RichText
        styles={{
          ul: 'mx-auto max-w-4xl space-y-1',
          li: 'text-xs leading-5 text-gray-600 md:text-sm',
          strong: 'font-bold text-royal-500',
        }}
      >
        {data.documentDetails}
      </RichText>
    </section>
  );
}
